import {REQUESTED_COMMITTEES} from '../actions';
import '../global';

export default (state = getRequestedCommittees(), action) => {
	switch (action.type) {
		case REQUESTED_COMMITTEES:
			let mapStateIndex = '';
			state.forEach(function(element,index){
				if(element.CODE === action.payload){
					mapStateIndex = index;
				}
			});

			if(mapStateIndex.length !== '' && typeof mapStateIndex === 'number'){
				let commIndex = mapStateIndex;
				let newState = [...state.slice(0,commIndex), ...state.slice(commIndex +1)];
				return [ ...newState ];
			}
			else {
				return state;
			}
	}
	return state;
}